import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ShareFBTwitter from '../share-fb-twitter/shareFBTwitter';
import GameButton from '../game-button/gameButton';
import ScoreSuffix from './scoreSuffix';
import Messages from './messages';

const GameEndEliminationWrap = styled.section`
  display: table;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  text-align: center;
`;

const GameEndEliminationWrapper = styled.section`
  display: table-cell;
  vertical-align: middle;
  background-color: rgba(0,0,0,.6);
  padding: 30px;

  @media screen and (min-width: ${props => props.theme.breakpoints.large}) {
    padding: 60px 20px;
  }
`;

const GameEndEliminationScoreText = styled.p`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fontFamily.primary};
  font-size: 24px;
  font-weight: bold;
  text-align: center;
    
  @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
    line-height: 2px;
  }
`;

const GameEndEliminationScore = styled.p`
  color: ${props => props.theme.colors.accent1};
  font-family: ${props => props.theme.fontFamily.primary};
  font-size: 70px;
  font-weight: bold;
  text-align: center;
`;

const GameEndEliminationSupportingText = styled.p`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fontFamily.primary};
  font-size: 16px;
  margin-bottom: 26px;
  margin-left: 38px;
  margin-right: 38px;
  text-align: center;
`;

const GameEndEliminationScoreTextBlock = styled.p`
    margin-bottom: 29px;
`;

const GameEndEliminationShareButtons = styled.section`
    margin-bottom: 68px;

    @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
        margin-bottom: 30px;
    }
`;

const GameEndEliminationLink = styled.p`
    margin-left: 38px;
    margin-right: 38px;
`;

const LogoElimination = styled.h1`
    background-position: 0 0;
    background-repeat: no-repeat;
    background-image: url('/images/elimination.png');
    background-image: url('/images/elimination.svg');
    background-size: 6em 3.875em;
    font-size: 30px;
    margin-bottom: 12px;
    content: ' ';
    display: inline-block;
    height: 3.875em;
    width: 6em;
    margin-top: -50px;
  
    @media screen and (min-width: ${props => props.theme.breakpoints.med}) {
      font-size: 46px;
    }
`;

export default class GameEndElimination extends Component {

  constructor(props) {
    super(props);

    this.playAgain = this.playAgain.bind(this);
    this.exitGame = this.exitGame.bind(this);

    this.gifImageDir = '/images/gifs';
    this.gifUrl = `${this.gifImageDir}/challenge_complete.gif`;
    this.scoreSuffix = new ScoreSuffix();
    this.messages = new Messages();
  }

  componentDidMount() {
    this.initSurveyMonkey();
  }
  
  initSurveyMonkey() {
    window.SMCX = [];

    let el = document.createElement('script');
    el.id = 'smcx-sdk';
    el.type='text/javascript';
    el.src = 'http://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd_2B2ieUunqoKroksufM0_2F9SNC2U1l74Oa7UVgP_2FtXYKCc.js';
    el.async = true;
    const scriptTags = document.getElementsByTagName('script');
    const lastScriptTag = scriptTags[scriptTags.length-1];
    lastScriptTag.parentNode.insertBefore(el, lastScriptTag);

    el.onload = function() {
      window.SMCX.push();
    };
  }

  playAgain() {
    window.dataLayer.push({
      eventAction: 'Click',
      eventlabel: 'Play Again Button',
      eventCategory: 'Game Over',
      gametype : 'elimination',
      event: 'eventPush',
    });

    this.props.playAgainHandler();
  }

  exitGame() {
    window.dataLayer.push({
      eventAction: 'Click',
      eventlabel: 'Menu Button',
      eventCategory: 'Game Over',
      gametype: 'elimination',
      event: 'eventPush',
    });

    this.props.exitGameHandler();
  }

  render() {
    return (
      <GameEndEliminationWrap style={{ backgroundImage: `url(${this.gifUrl})` }}>
        <GameEndEliminationWrapper>
          <LogoElimination className='ir'>The Higher Lower Game - Elimination Mode</LogoElimination>
          <GameEndEliminationScoreTextBlock>
            <GameEndEliminationScoreText>You came</GameEndEliminationScoreText>
            <GameEndEliminationScore><span>{this.props.score}</span>{this.scoreSuffix.getScoreSuffix(this.props.score)}</GameEndEliminationScore>
            <GameEndEliminationScoreText>out of {this.props.playerCount}</GameEndEliminationScoreText>
          </GameEndEliminationScoreTextBlock>
          <GameEndEliminationSupportingText>{this.messages.getMessage(this.props.score)}</GameEndEliminationSupportingText>
          <GameEndEliminationShareButtons>
            <ShareFBTwitter />
          </GameEndEliminationShareButtons>
          <GameButton id='main-menu-btn' text='Back to menu' clickHandler={this.exitGame} />
          <GameButton id='game-over-btn' text='Play again' clickHandler={this.playAgain} />
          <GameEndEliminationLink>Follow us for updates <a target='_blank' rel='noopener noreferrer' href='//twitter.com/higherlowergame'>@HigherLowerGame</a></GameEndEliminationLink>
        </GameEndEliminationWrapper>
      </GameEndEliminationWrap>
    );
  }
}

GameEndElimination.propTypes = {
  score: PropTypes.number,
  playerCount: PropTypes.number,
  playAgainHandler: PropTypes.func,
  exitGameHandler: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/elimination-end/gameEndElimination.js